module.exports = __webpack_public_path__ + "img/service_icon3.59acf92a.png";